import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import socketIOClient from 'socket.io-client';
import styled from 'styled-components';
import GaugeChart from 'react-gauge-chart';
import { ChugActions } from '../../redux/ChugWars';
import { getFormattedPlayerData } from '../../redux/ChugWars/selectors';

const isProduction = process.env.NODE_ENV === 'production';
const URI = isProduction
  ? 'http://ryysterbrewery.com:3000'
  : 'http://localhost:3000';

const Title = styled.h1`
  font-size: 4em;
  margin-top: 6rem;
  align-self: center;
  text-align: center;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const GaugeContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const GaugeWrapper = styled.div`
  background-color: ${(props) => (props.percentage < 0 ? 'red' : 'white')};
`;

const ChugWars = () => {
  const dispatch = useDispatch();
  const playerStates = useSelector((state) => getFormattedPlayerData(state));
  useEffect(() => {
    dispatch(ChugActions.fetchState());
    const socket = socketIOClient(URI);
    socket.on('STATE_UPDATE', (data) => {
      dispatch(ChugActions.updatePlayerState(data));
    });

    return () => socket.disconnect();
  }, []);

  const Players = playerStates.map((player) => {
    return (
      <GaugeWrapper percentage={player.percentage} key={player.playerName}>
        <Title>{player.playerName}</Title>
        <GaugeChart
          id={player.playerName}
          percent={player.percentage}
          colors={['#DD0000', '#DDD400', '#24DD00']}
          textColor="#000000"
          formatTextValue={() => player.dept + ' ml'}
        />
      </GaugeWrapper>
    );
  });
  return (
    <MainContainer>
      <Title>ChugWars!</Title>
      <GaugeContainer>{Players}</GaugeContainer>
    </MainContainer>
  );
};

export default ChugWars;
